import { Component, ElementRef, HostListener } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { AuthService } from '@Services/auth.service';
import { DragDropService } from '@Services/drag-drop.service';
import { AlertsHub } from '@Core/hubs/alerts.hub';

@Component({
    standalone: false,
    selector: 'conf',
    templateUrl: './conf.component.html',
    styleUrls: ['./conf.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ConfComponent {
    public isMainMenuOpen = false;

    constructor(public authService: AuthService,
        private elementRef: ElementRef,
        private dragDropService: DragDropService,
        private alertsHub: AlertsHub) {
        this.authService.spaName = 'conf';
    }

    ngOnInit() {
        this.alertsHub.startConnection();
    }

    public toggleMainMenu(event: MouseEvent): void {
        event.stopPropagation();
        this.isMainMenuOpen = !this.isMainMenuOpen;
    }

    @HostListener('document:click')
    public closeMainMenu(): void {
        this.isMainMenuOpen = false;
    }

    onDragOver(event: DragEvent): void {
        event.stopPropagation();
        event.preventDefault();
        this.dragDropService.setDragging(true);
    }

    onDragLeave(event: DragEvent): void {
        if (!event.relatedTarget || !this.elementRef.nativeElement.contains(event.relatedTarget)) {
            this.dragDropService.setDragging(false);
        }
    }
};
